<template>
  <div class="form-check">
    <input
      class="form-check-input"
      :id="id"
      type="checkbox"
      :value="val"
      v-bind="$attrs"
      v-model="checked"
      @change="onChange"
    />
    <label v-if="label" class="form-check-label font-weight-normal" :for="id">
      {{ label }}
    </label>

    <Error v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import Error from '@/Shared/Inputs/Error';

export default {
  inheritAttrs: false,

  components: {
    Error,
  },

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `textarea-input-${this._uid}`;
      },
    },
    label: String,
    value: [Array, Number],
    val: [String, Number],
    errors: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      checkedProxy: false,
    };
  },

  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkedProxy = val;
      },
    },
  },

  methods: {
    onChange() {
      this.$emit('input', this.checkedProxy);
    },
  },
};
</script>
